import { api } from "../../App/services/api";
function all(referenceDate, status, page, rows) {
    if (referenceDate === void 0) { referenceDate = ''; }
    if (status === void 0) { status = 0; }
    if (page === void 0) { page = 1; }
    if (rows === void 0) { rows = 20; }
    var uri = "/billings?per_page=".concat(rows, "&page=").concat(page);
    uri = referenceDate === '' ?
        uri :
        uri + "&reference_date=".concat(referenceDate);
    uri = status === 0 ?
        uri :
        uri + "&status=".concat(status);
    return api.get(uri);
}
function paginate(url) {
    return api.get(url);
}
function paginateBenefit(url, params) {
    if (params === void 0) { params = {}; }
    return api.get(url, { params: params });
}
function find(billingId, page, rows) {
    if (page === void 0) { page = 1; }
    if (rows === void 0) { rows = 20; }
    return api.get("/billings/".concat(billingId, "?per_page=").concat(rows, "&page=").concat(page));
}
function getSubscriberTokenBillingReport(billingId, tokenId) {
    return api.get("/billings/".concat(billingId, "/subscriber/token/").concat(tokenId, "/report"));
}
function exportSubscriberTokenBillingReport(reportData) {
    return api.post('/billings/subscriber/token/report/export', { report_data: reportData });
}
function exportDetailedBillingReport(billingId, config) {
    if (config === void 0) { config = {}; }
    return api.get("/billings/".concat(billingId, "/export"), config);
}
function getLastBilling() {
    return api.get("/billings/last");
}
function getBankSlip(billingId) {
    return api.get("/billings/".concat(billingId, "/bank-slip"), { responseType: 'arraybuffer' });
}
function getBankSlipLicense(billingId) {
    return api.get("/billings/".concat(billingId, "/bank-slip-license"), { responseType: 'arraybuffer' });
}
function generateBillingSummary(billingId) {
    return api.get("/billings/".concat(billingId, "/summary/generate"), { responseType: 'arraybuffer' });
}
function customerHasBenefit(billingId) {
    return api.get("CustomerProduct/checkIfCustomerHasBenefit", {
        params: { billing_id: billingId }
    });
}
function getVouchers(billing_id, page, rows) {
    if (page === void 0) { page = 1; }
    if (rows === void 0) { rows = 20; }
    return api.get("CustomerProduct/getVouchers?per_page=".concat(rows), {
        params: { billing_id: billing_id }
    });
}
function updateVoucherStatus(voucherId, newStatus) {
    return api.post("CustomerProduct/updateVoucherStatus", { voucherId: voucherId, newStatus: newStatus });
}
function getInvoices(billingLicenseId) {
    return api.get("/billings/".concat(billingLicenseId, "/invoices"));
}
function getDiscountCoupons() {
    return api.get("/discount-coupons");
}
export default {
    all: all,
    paginate: paginate,
    find: find,
    getSubscriberTokenBillingReport: getSubscriberTokenBillingReport,
    exportSubscriberTokenBillingReport: exportSubscriberTokenBillingReport,
    exportDetailedBillingReport: exportDetailedBillingReport,
    getLastBilling: getLastBilling,
    getBankSlip: getBankSlip,
    getBankSlipLicense: getBankSlipLicense,
    generateBillingSummary: generateBillingSummary,
    customerHasBenefit: customerHasBenefit,
    getVouchers: getVouchers,
    updateVoucherStatus: updateVoucherStatus,
    paginateBenefit: paginateBenefit,
    getInvoices: getInvoices,
    getDiscountCoupons: getDiscountCoupons
};
